import React, { useEffect, useState, useRef } from "react";
import { useHistory } from "@/app/hooks/useHistory";

import apiAgent from "../../../app/api/apiAgent";
import DealContactsStepView from "../dealComponents/stepComponents/DealContactsStepView";
import DealDocumentStepView from "../dealComponents/stepComponents/DealDocumentStepView";
import { OMSButtonStyleL } from "../../../app/common/common-components/OMSButton";
import { toast } from "react-toastify";
import DealOverviewStepView from "../dealComponents/stepComponents/DealOverviewStepView";
import "react-vertical-timeline-component/style.min.css";
import DealFinanceStepView from "../dealComponents/stepComponents/DealFinanceStepView";
import DealTaskStepView from "../dealComponents/stepComponents/DealTaskStepView";
import ConfirmationModalPopup from "../../../app/common/common-components/ModalPopups/ConfirmationModalPopup";
import { AuditTrailBox } from "../../contact/AuditTrailBox";
import { useStore } from "../../../app/stores/store";
import { isEntegralSuperUser, isStandardViewOnlyUsers } from "../../../app/common/common-functions/functions";

function DealBox(props) {
  const refFinanceComponent = useRef();
  const refTaskComponent = useRef();
  const refOverviewComponent = useRef();
  const [internalDealDefaultTags, setInternalDealDefaultTags] = useState([]);
  const [isMobileWidth, setIsMobileWidth] = useState(window.innerWidth <= 460);
  const [accessType, setAccessType] = useState(null);
  const [superAdmin, setSuperAdmin] = useState(false);
  const [newDealData, setNewDealData] = useState();
  const [dealModelData, setDealModelData] = useState({
    dealname: "",
    dealDate: "",
    dealTemplete: "",
    dealTempleteId: "",
    pipeline: "",
    pipelineId: "",
    mandateStatus: "0",
  });

  const getSelectedTagNames = () => {
    const tags = [...internalDealDefaultTags];
    return tags.filter((tag) => tag.isSelected).map((tag) => tag.name);
  };

  const getInternalDefaultTags = (tags) => {
    var items = [];
    for (const tagElement of tags) {
      var item = {
        name: tagElement,
        isSelected: props.data.internalDealTags.includes(tagElement),
      };
      items.push(item);
    }
    return items;
  };
  const handleTagClick = (index) => {
    const defaultTagList = [...internalDealDefaultTags];
    defaultTagList[index].isSelected = !defaultTagList[index].isSelected;
    setInternalDealDefaultTags(defaultTagList);
  };
  const [deductionTypesDD, setDeductionTypesDD] = useState([
    {
      text: "",
      value: "",
    },
  ]);
  const [splitTypesDD, setSplitTypesDD] = useState([
    {
      text: "",
      value: "",
    },
  ]);
  const [dealTEmpleteDD, setdealTEmpleteDD] = useState([]);
  const [dealPipelineDD, setDealPipelineDD] = useState([]);
  const [documentTaskDD, setdocumentTaskDD] = useState([]);
  const [contactDD, setContactDD] = useState([]);
  const [step, setStep] = useState(0);
  const [documents, setDocuments] = useState([]);
  const [contacts, setContacts] = useState([]);
  const [buttonStatus, setButtonStatus] = useState({
    disabled: false,
    processing_save: false,
    processing_delete: false,
    processing_history: false,
  });
  const [confirmationModalProps, setConfirmationModalProps] = useState({
    showModal: false,
    isConfirmed: (result) => { },
    title: "",
    body: "",
  });
  const [taskData, setTaskData] = useState([]);
  const [isShowAuditTrail, setIsShowAuditTrail] = useState(false);
  const [allAssignedTags, setallAssignedTags] = useState([]);
  const [taskIDParam, settaskIDParam] = useState("");

  const {
    userStore: { userSession },
  } = useStore();

  const history = useHistory();

  const onCancelClick = () => {
    history.push("/deal");
  };
  const onHandleDealNote = (note) => {
    props.data.dealNote = note;
  };

  const onChangeStartDate = (sDate) => {
    setNewDealData((prev) => ({
      ...prev,
      startDate: sDate,
    }));

  };
  const onHandleDealMilestone = (dealStage) => {
    setNewDealData({ ...newDealData, dealStage: dealStage });
  };

  // Input Value Handle
  const inputHandler = async (e, inpName) => {
    if (inpName === "dealName") {
      setDealModelData({ ...dealModelData, dealname: e.target.value });
    } else if (inpName === "dealDate") {
      setDealModelData({ ...dealModelData, dealDate: e.target.value });
    } else if (inpName === "dealTemplete") {
      setDealModelData({
        ...dealModelData,
        dealTemplete: e.newText,
        dealTempleteId: e.newValue,
      });
    } else if (inpName === "dealPipeline") {
      console.log("dealPipeline ::: ", e);

      let templete = props.data.templatesDD.filter((curElem) => {
        return curElem.pipelineId === e.newValue;
      });
      templete.unshift({
        pipeline: "",
        template: "",
        pipelineId: "",
        templateId: "",
      });
      setDealModelData({
        pipeline: e.newText,
        pipelineId: e.newValue,
        dealTemplete: dealModelData.dealTempleteId,
        dealDate: dealModelData.dealDate,
        dealname: dealModelData.dealname,
      });
      setdealTEmpleteDD(templete);
    } else if (inpName === "mandateStatus") {
      setDealModelData({ ...dealModelData, mandateStatus: e.target.value });
    }
  };
  const onFileComponentChange = (files) => {
    setDocuments(files);
  };
  const onContactComponentChange = (contacts) => {
    setContacts(contacts);
    let newContcatDD = contacts
      ?.filter((curContact) => {
        return curContact.type == 1;
      })
      ?.map((curContact) => {
        return { value: curContact.id, text: curContact.displayName };
      });
    newContcatDD.unshift({ value: "", text: "" });
    setContactDD(newContcatDD);
  };

  // Task Data Change Handle
  const onTaskDataChange = (newTaskData, newDocumentModel, deleteDocumentModel) => {
    setTaskData(newTaskData);
    if (newDocumentModel !== undefined && newDocumentModel !== null) {
      var mDocuments = [...documents];
      mDocuments.push(newDocumentModel);
      setDocuments(mDocuments);
    }
    if (deleteDocumentModel !== undefined && deleteDocumentModel !== null) {
      var mDocuments = [...documents];
      mDocuments = documents.filter((doc) => doc.fileID != deleteDocumentModel.fileID);
      setDocuments(mDocuments);
    }
  };

  // model Handlers
  const onDealNameModelOpen = () => {
    setDealModelData({ ...dealModelData, dealname: newDealData.dealName });
    window.$("#deal_name_model").modal("show");
  };

  // Edit Handlers
  const onDealNameEditSave = (e) => {
    window.$("#deal_name_model").modal("hide");
    setNewDealData({ ...newDealData, dealName: dealModelData.dealname });
  };

  // Other Functions
  const doChangeStepClick = (step) => {
    setStep(step);
    removeTaskParam();
  };
  const removeTaskParam = () => {
    const params = new URLSearchParams(window.location.search);

    // Remove the 'taskId' parameter
    if (params.has("taskId")) {
      params.delete("taskId");

      // Update the URL without reloading the page
      const newUrl = `${window.location.pathname}?${params.toString()}`;
      window.history.pushState({}, "", newUrl);
      settaskIDParam("");
      //props.removeTaskId();
    }
  };

  const handleStep = (action) => {
    //console.log("handleStep :: ", step, action, props.dealID, newDealData.dealId);

    if (action === "next") {
      if (step === 0 && !props.dealID && !newDealData.dealId) {
        const params = new URLSearchParams(window.location.search);
        if (!params.has("isModify")) {
          history.push(window.location.pathname + window.location.search + "&isModify=true");
          onNextCallHandle();
        } else {
          setStep(step + 1);
        }
      }
      if (step < 4 && step >= 0) {
        if (step != 0) {
          setStep(step + 1);
        }
      }
    } else if (action === "back") {
      if (step > 0) {
        setStep(step - 1);
      }
    }
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobileWidth(window.innerWidth <= 460);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    let taskId = "";

    if (!props.dealID) {
      setAccessType(1);
    } else if (userSession.role) {
      if (userSession.role == "EntegralSuperUser" || userSession.role == "OfficeAdministrator" || userSession.role == "GroupAdministrator") {
        setAccessType(1);
        if (userSession.role == "EntegralSuperUser") {
          setSuperAdmin(true);
        }
      } else {
        setAccessType(0);
      }
    } else {
      setAccessType(null);
    }

    if (params.has("taskId")) {
      const id = params.get("taskId");
      taskId = id !== null ? id : "";
      settaskIDParam(taskId);
    }

    if (taskId != "") {
      setStep(1);
    }
  }, []);
  useEffect(() => {
    if (!props.data) return;

    setNewDealData(props.data);

    // Set tags
    let tagData = [];
    if (props.data.officeContactTags?.length) {
      tagData = [...tagData, ...props.data.officeContactTags];
    }
    if (props.data.agentTypesDD?.length) {
      tagData = [...tagData, ...props.data.agentTypesDD];
    }

    setInternalDealDefaultTags(getInternalDefaultTags(props.data.internalDealTagsList || []));
    setallAssignedTags(tagData);

    // Set task data
    const stages = props.data.stages || [];
    setTaskData(stages);

    // If deal exists, set form and dropdown data
    if (props.data) {
      const { startDate, pipelinesDD = [], pipeline, pipelineId, templatesDD = [], templateId, dealName } = props.data;

      // Format date (safe fallback if startDate is undefined or invalid)
      const formatedDate = startDate?.split("-").reverse().join("-");

      const activePipeline = pipeline || pipelinesDD[0]?.text || "";
      const activePipelineId = pipelineId || pipelinesDD[0]?.value || "";

      const filteredTemplates = templatesDD.filter((t) => t.pipelineId == activePipelineId);
      filteredTemplates.unshift({
        pipeline: "",
        template: "",
        pipelineId: "",
        templateId: "",
      });

      setDealModelData({
        dealDate: formatedDate,
        dealname: dealName,
        dealTempleteId: templateId,
        pipeline: activePipeline,
        pipelineId: activePipelineId,
      });

      setDealPipelineDD(pipelinesDD);
      setdealTEmpleteDD(filteredTemplates);

      // Set document task dropdown
      if (stages.length > 0) {
        const tasks = [
          {
            taskId: "",
            taskName: "",
            status: 0,
            assignedRoles: [],
            comments: "",
            description: "",
          },
        ];
        stages.forEach((stage) => {
          stage.stageTasks?.forEach((task) => tasks.push(task));
        });
        setdocumentTaskDD(tasks);
      }

      // Documents, Contacts, ContactDD
      if (props.data.documents?.length > 0) {
        console.log("newDealData.documents.length  :: ", props.data.documents.length);
        setDocuments(props.data.documents);
      }

      if (props.data.contacts?.length > 0) {
        setContacts(props.data.contacts);
      }

      setContactDD(props.data.contactDD);

      // Deduction Types
      if (props.data.deductionTypesDD?.length > 0) {
        const deductionMapped = props.data.deductionTypesDD.map((d) => ({
          text: d.deduction_name,
          value: d.deduction_name,
          deductionName: d.deduction_name,
          deductionPercentage: d.deduction_percentage,
          deductionAmount: d.deduction_amount,
          isVatExcluded: d.is_vat_excluded,
        }));
        setDeductionTypesDD(deductionMapped);
      }

      // Split Types
      if (props.data.splitTypesDD?.length > 0) {
        const splitMapped = props.data.splitTypesDD.map((s) => ({
          text: s.split_name,
          value: s.split_name,
          splitPercentage: s.split_percentage,
          splitAmount: s.split_amount,
          splitTaxed: s.split_taxed,
          splitName: s.split_name,
        }));
        setSplitTypesDD(splitMapped);
      }
    }
  }, [props.data]);

  // Submit Handles
  const onNextCallHandle = () => {
    //console.log("Next Btn ::: ", dealModelData);

    const selectedDealTags = getSelectedTagNames();
    if (dealModelData.dealname == "" || dealModelData.dealname == undefined || dealModelData.dealname == null) {
      toast.info("Enter a valid Deal Name");
    } else {
      setButtonStatus({
        disabled: true,
        processing_save: true,
        processing_delete: false,
        processing_history: false,
      });
      let pipeline = "";
      let pipelineId = "";

      if (newDealData.dealID) {
        pipeline = newDealData.pipeline;
        pipelineId = newDealData.pipelineId;
      } else {
        pipelineId = dealModelData.pipelineId;
        pipeline = dealModelData.pipeline;
      }

      let financeModel = refFinanceComponent.current.getData();

      let model = {
        dealID: newDealData.dealID,
        officeID: newDealData.officeID,
        userID: newDealData.userID,
        propertyID: newDealData.propertyID,
        dealName: dealModelData.dealname,
        template: dealModelData.dealTemplete,
        templateId: dealModelData.dealTempleteId,
        startDate: dealModelData.dealDate,
        mandateStatus: dealModelData.mandateStatus,
        pipeline: pipeline,
        pipelineId: pipelineId,
        dealStage: newDealData.dealStage,
        dealStageId: newDealData.dealStageId,
        stages: [],
        documents: [],
        dealRef: newDealData.dealRef,
        templatesDD: newDealData.templatesDD,
        pipelinesDD: newDealData.pipelinesDD,
        assignedRolesDD: newDealData.assignedRolesDD,
        agentTypesDD: newDealData.agentTypesDD,
        contactSourceTypes: newDealData.contactSourceTypes,
        officeContactTags: newDealData.officeContactTags,
        contacts: [],
        dialingCodeDD: newDealData.dialingCodeDD,
        dialingCode: newDealData.dialingCode,
        syncId: newDealData.syncId,
        finance: financeModel,
        splitTypesDD: newDealData.splitTypesDD,
        deductionTypesDD: newDealData.deductionTypesDD,
        internalDealTags: selectedDealTags,
      };
      apiAgent.Deal.saveDealAjax(model).then((res) => {
        setNewDealData(res);
        //toast.info("Deal data saved successfully");

        setButtonStatus({
          disabled: false,
          processing_save: false,
          processing_delete: false,
          processing_history: false,
        });
        setStep(step + 1);
      });
    }
  };
  const onSubmitHandle = (isDealClose) => {
    const selectedDealTags = getSelectedTagNames();
    //console.log("Selected Tags ::: ", selectedDealTags);

    setButtonStatus({
      disabled: true,
      processing_save: true,
      processing_delete: false,
      processing_history: false,
    });
    let pipeline = "";
    let pipelineId = "";
    let docData = [];
    if (newDealData.dealID) {
      pipeline = newDealData.pipeline;
      pipelineId = newDealData.pipelineId;

      docData = documents?.map((doc) => {
        return {
          fileID: doc.fileID,
          fileName: doc.fileName,
          description: doc.description,
          fileicon: doc.fileicon,
          size: doc.size,
          displaySize: doc.displaySize,
          url: "",
          uploadedTime: doc.uploadedTime,
          taskID: doc.taskId,
          taskName: doc.taskName,
          comment: doc.comment,
        };
      });
    } else {
      //console.log("New Deal ::: ", dealModelData);

      pipeline = dealModelData.pipeline;
      pipelineId = dealModelData.pipelineId;
      docData = [];
    }

    let financeModel = refFinanceComponent.current.getData();

    let stageModel = [...taskData];
    let updatedStageModel = stageModel?.map((curStage, curStageIDX) => {
      let updatedTask = curStage.stageTasks?.map((curTask, curTaskIDX) => {
        return { ...curTask, taskIndex: curTaskIDX };
      });
      return { ...curStage, stageTasks: updatedTask };
    });

    let model = {
      dealID: newDealData.dealID,
      officeID: newDealData.officeID,
      userID: newDealData.userID,
      propertyID: newDealData.propertyID,
      dealName: dealModelData.dealname,
      template: newDealData.template,
      templateId: newDealData.templateId,
      startDate: dealModelData.dealDate,
      pipeline: pipeline,
      pipelineId: pipelineId,
      dealStage: newDealData.dealStage,
      dealStageId: newDealData.dealStageId,
      stages: updatedStageModel,
      documents: docData,
      dealRef: newDealData.dealRef,
      templatesDD: newDealData.templatesDD,
      pipelinesDD: newDealData.pipelinesDD,
      assignedRolesDD: newDealData.assignedRolesDD,
      agentTypesDD: newDealData.agentTypesDD,
      contactSourceTypes: newDealData.contactSourceTypes,
      officeContactTags: newDealData.officeContactTags,
      contacts: contacts,
      dialingCodeDD: newDealData.dialingCodeDD,
      dialingCode: newDealData.dialingCode,
      syncId: newDealData.syncId,
      finance: financeModel,
      splitTypesDD: newDealData.splitTypesDD,
      deductionTypesDD: newDealData.deductionTypesDD,
      dealNote: props.data.dealNote,
      internalDealTags: selectedDealTags,
    };
    apiAgent.Deal.saveDealAjax(model).then((res) => {
      setNewDealData(res);
      setDocuments(res.documents);
      if (isDealClose == "DealGrid") {
        setDashboardState("Deals");
        history.push(`/deal`);
      }
      if (isDealClose == "EditDeal") {
        if (newDealData.dealID) {
          const anchorTag = document.createElement("a");
          anchorTag.href = `/deal/saveDeal?ID=${newDealData.dealID}`;
          anchorTag.style.display = "none";
          document.body.appendChild(anchorTag);
          anchorTag.click();
        }
      }
      setButtonStatus({
        disabled: false,
        processing_save: false,
        processing_delete: false,
        processing_history: false,
      });
      //toast.info("Deal data saved successfully");
    });
  };

  //TO Delete The Deal
  const deleteDealCallBack = (result) => {
    setConfirmationModalProps({
      showModal: false,
      isConfirmed: (result) => { },
      title: "",
      body: "",
    });
    if (result == true) {
      setButtonStatus({
        disabled: true,
        processing_save: false,
        processing_delete: true,
        processing_history: false,
      });

      apiAgent.Deal.deletedealAjax(newDealData.dealID, newDealData.userID)
        .then((res) => {
          setDashboardState("Deals");
          history.push(`/deal`);
          setButtonStatus({
            disabled: false,
            processing_save: false,
            processing_delete: false,
            processing_history: false,
          });
        })
        .catch((err) => {
          setButtonStatus({
            disabled: false,
            processing_save: false,
            processing_delete: false,
            processing_history: false,
          });
        });
    } else {
      setButtonStatus({
        disabled: false,
        processing_save: false,
        processing_delete: false,
        processing_history: false,
      });
    }
  };
  const deleteDealHandle = () => {
    setConfirmationModalProps({
      showModal: true,
      isConfirmed: (result) => {
        deleteDealCallBack(result);
      },
      title: "Delete Deal",
      body: "Do you want to delete Deal now? This cannot be undone.",
    });
  };

  const handleAuditTrailClose = () => {
    setIsShowAuditTrail(false);
  };
  const handleAuditTrailShow = () => {
    setIsShowAuditTrail(true);
  };

  const toBackAtProperty = () => {
    history.push(`/Property/SaveProperty?ID=${props.data.propertyID}`);
  };

  const setDashboardState = (state) => {
    localStorage.setItem("view", state);
  };
  return (
    <>
      <ConfirmationModalPopup {...confirmationModalProps} />
      <div className="col-sm-12">
        <div className={newDealData?.dealID !== "" ? "panel panel-default oms-box color2 color2-border-right" : "panel panel-default oms-box"}>
          <div className="wrap">
            <div className="left">
              <div className="panel-heading">
                <div className="row">
                  <div className="col-md-6 col-sm-6 col-xs-12 mt-1">
                    {newDealData?.dealID ? (
                      <div style={{ display: "flex" }}>
                        <div className="name-container">
                          <h5>{`#${newDealData?.dealRef} :  ${newDealData?.dealName}`}</h5>
                        </div>
                        <div className="edit-icon-container" style={{ alignSelf: "center" }}>
                          {accessType == 1 && <i onClick={() => onDealNameModelOpen()} className="fa fa-edit mx-2"></i>}
                        </div>
                      </div>
                    ) : (
                      <h5>{`New Deal`}</h5>
                    )}
                  </div>
                  <div className="col-md-6 col-sm-6 col-xs-12 mt-1">
                    <div className="task-internal-deal-tags">
                      {internalDealDefaultTags && (
                        <div className="tag-list">
                          <span
                            data-toggle="modal"
                            style={{
                              cursor: "pointer",
                              verticalAlign: "middle",
                              backgroundColor: "transparent",
                              display: isStandardViewOnlyUsers(userSession) && "none",
                            }}
                            className="listingTag"
                            data-target="#internal-deal-tag"
                            title="Deal Tags"
                          >
                            <i className="fa fa-tags" style={{ fontSize: 12 }} aria-hidden="true"></i>
                          </span>
                          {internalDealDefaultTags.map((tagElement, index) => {
                            return (
                              <>
                                {tagElement.isSelected && (
                                  <span key={`internal-listing-tags-${index}`} className="listingTag">
                                    {tagElement.name}
                                  </span>
                                )}
                              </>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="panel-body" style={{ backgroundColor: "white", minHeight: 600 }}>
                <div className="col-md-12">
                  <div id="overview" style={{ display: step == 0 ? "" : "none" }}>
                    <DealOverviewStepView
                      ref={refOverviewComponent}
                      newDealData={newDealData}
                      data={newDealData?.stages}
                      contacts={contacts}
                      dealModelData={dealModelData}
                      dealPipelineDD={dealPipelineDD}
                      dealTEmpleteDD={dealTEmpleteDD}
                      inputHandler={inputHandler}
                      onDataChange={onTaskDataChange}
                      assignedRolesDD={newDealData?.assignedRolesDD}
                      syncId={newDealData?.syncId}
                      goToProperty={toBackAtProperty}
                      accessType={accessType}
                      userSession={userSession}
                      currency={newDealData?.currency}
                      dealNote={props.data.dealNote}
                    />
                  </div>
                  <div id="Tasks" style={{ display: step == 1 ? "" : "none" }}>
                    <DealTaskStepView
                      ref={refTaskComponent}
                      UserID={newDealData?.userID}
                      dealID={newDealData?.dealID}
                      dealName={newDealData?.dealName}
                      data={newDealData?.stages}
                      startDate={newDealData?.startDate}
                      onChangeStartDate={onChangeStartDate}
                      contacts={contacts}
                      assignedRolesDD={newDealData?.assignedRolesDD}
                      onDataChange={onTaskDataChange}
                      syncId={newDealData?.syncId}
                      accessType={accessType}
                      superAdmin={superAdmin}
                      userSession={userSession}
                      allTags={allAssignedTags}
                      taskId={taskIDParam}
                      dealNote={newDealData?.dealNote}
                      onChangeDealNote={onHandleDealNote}
                      actions={props?.data?.actions}
                      onChangeDealMilestone={onHandleDealMilestone}
                      internalDealTagsList={props.data.internalDealTagsList}
                      internalDealSelectedTag={props.data.internalDealTags}
                    />
                  </div>
                  <div id="Contacts" style={{ display: step == 2 ? "" : "none" }}>
                    <div className="row">
                      <DealContactsStepView
                        id="dealContactsStep"
                        super_access={true}
                        OfficeID={newDealData?.officeID}
                        DealID={newDealData?.dealID}
                        UserID={newDealData?.userID}
                        DialingCode={newDealData?.dialingCode}
                        DialingCodeDD={newDealData?.dialingCodeDD}
                        OfficeContactTags={newDealData?.officeContactTags}
                        UserContactTags={[]}
                        AgentTypes={newDealData?.agentTypesDD}
                        ContactSourceTypes={newDealData?.contactSourceTypes}
                        Contacts={contacts}
                        onChange={onContactComponentChange}
                        accessType={accessType}
                        userSession={userSession}
                      />
                    </div>
                  </div>
                  <div id="Documents" style={{ display: step == 3 ? "" : "none" }}>
                    <div className="row">
                      <DealDocumentStepView
                        save_access={true}
                        data={documents}
                        onChange={onFileComponentChange}
                        officeSyncID={props.officeSyncID}
                        propertyID={props.dealID}
                        taskDD={documentTaskDD}
                        syncId={newDealData?.syncId}
                        accessType={accessType}
                        userSession={userSession}
                        taskData={taskData}
                        actions={props?.data?.actions}
                      />
                    </div>
                  </div>
                  <div id="Finance" style={{ display: step == 4 ? "" : "none" }}>
                    <DealFinanceStepView
                      ref={refFinanceComponent}
                      id="dealFinanceStep"
                      currency={newDealData?.currency}
                      super_access={true}
                      OfficeID={newDealData?.officeID}
                      DealID={newDealData?.dealID}
                      UserID={newDealData?.userID}
                      Finance={newDealData?.finance}
                      deductionTypesDD={deductionTypesDD}
                      splitTypesDD={splitTypesDD}
                      contacts={contacts}
                      accessType={accessType}
                      userSession={userSession}
                    />
                  </div>
                </div>
              </div>
              <div className="panel-footer">
                <div className="row">
                  <div className="col-md-12">
                    <div className="col-md-6">
                      {props.dealID !== "" ? (
                        <div className={isMobileWidth ? "btn-pull-center" : "pull-left"}>
                          <div className="dropup">
                            <button className="btn btn-outline dropdown-toggle" type="button" data-toggle="dropdown">
                              More..
                              <span className="caret" />
                            </button>
                            <ul className="dropdown-menu">
                              {accessType == 1 && (
                                <li key="delete">
                                  <OMSButtonStyleL
                                    style={{ marginRight: 10 }}
                                    type="button"
                                    ui_icon="fa-trash-o"
                                    ui_type="cancel"
                                    ui_text="Delete deal"
                                    ui_processing_text="Deleting.."
                                    processing={buttonStatus.processing_delete}
                                    disabled={buttonStatus.disabled}
                                    onClick={() => deleteDealHandle()}
                                  />
                                </li>
                              )}
                              {accessType == 1 && (
                                <li key="history">
                                  <OMSButtonStyleL
                                    style={{ marginRight: 10 }}
                                    type="button"
                                    ui_icon="fa-history"
                                    ui_type="cancel"
                                    ui_text="History"
                                    ui_processing_text="opening history...."
                                    processing={buttonStatus.processing_delete}
                                    disabled={buttonStatus.disabled}
                                    onClick={() => handleAuditTrailShow()}
                                  />
                                </li>
                              )}
                            </ul>
                          </div>
                        </div>
                      ) : (
                        <label style={{ padding: "6px 12px" }}>Step {step + 1} of 5 </label>
                      )}
                    </div>
                    <div className="col-md-6">
                      <div className="btn-right">
                        {props.dealID !== "" ? (
                          <>
                            <OMSButtonStyleL
                              style={{ marginRight: 10 }}
                              type="button"
                              ui_icon="fa-times"
                              ui_class="btnCtrl"
                              ui_type="cancel"
                              ui_text="Cancel"
                              ui_processing_text=""
                              processing={false}
                              disabled={buttonStatus.disabled}
                              onClick={onCancelClick}
                            />
                            {props?.data?.actions?.indexOf("save") != -1 && (
                              <>
                                <OMSButtonStyleL
                                  style={{ marginRight: 5 }}
                                  type="button"
                                  ui_icon="fa-check"
                                  ui_type="save"
                                  ui_text="Save"
                                  ui_processing_text="Saving.."
                                  processing={buttonStatus.processing_save}
                                  disabled={buttonStatus.disabled}
                                  onClick={() => onSubmitHandle(null)}
                                />
                                <OMSButtonStyleL
                                  style={{ marginRight: 0 }}
                                  type="button"
                                  ui_icon="fa-check"
                                  ui_type="save"
                                  ui_text="Save & close"
                                  ui_processing_text="Saving.."
                                  processing={buttonStatus.processing_save}
                                  disabled={buttonStatus.disabled}
                                  onClick={() => onSubmitHandle("DealGrid")}
                                />
                              </>
                            )}
                          </>
                        ) : (
                          <div>
                            {step <= 0 ? null : (
                              <>
                                {step === 0 ? null : (
                                  <button onClick={() => handleStep("back")} className="btn btn-success-oms mx-2">
                                    <i className="fa fa-arrow-left"></i> Previous
                                  </button>
                                )}
                              </>
                            )}
                            {step >= 4 ? null : (
                              <OMSButtonStyleL
                                style={{ marginRight: 10 }}
                                type="button"
                                ui_icon="fa-arrow-right"
                                ui_type="save"
                                ui_text="Next"
                                ui_processing_text="Saving.."
                                processing={buttonStatus.processing_save}
                                disabled={buttonStatus.disabled}
                                onClick={() => handleStep("next")}
                              />
                            )}
                            {step === 4 ? (
                              <OMSButtonStyleL
                                style={{ marginRight: 10 }}
                                type="button"
                                ui_icon="fa-check"
                                ui_type="save"
                                ui_text="Save"
                                ui_processing_text="Saving.."
                                processing={buttonStatus.processing_save}
                                disabled={buttonStatus.disabled}
                                onClick={() => onSubmitHandle("EditDeal")}
                              />
                            ) : null}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {props.dealID == "" ? null : (
              <div className="right color2 hidden-xs hidden-sm">
                <div className="row">
                  <div className="col-md-12">
                    <a className={step == 0 ? "btn text-center property-menu-selected" : "btn text-center property-menu"} onClick={() => doChangeStepClick(0)}>
                      <span>
                        <i className="fa fa-tachometer fa-2x"></i>
                        <br />
                        Overview
                      </span>
                    </a>
                    <a className={step == 1 ? "btn text-center property-menu-selected" : "btn text-center property-menu"} onClick={() => doChangeStepClick(1)}>
                      <span>
                        <i className="fa fa-clock-o fa-2x"></i>
                        <br />
                        Tasks
                      </span>
                    </a>
                    <a className={step == 2 ? "btn text-center property-menu-selected" : "btn text-center property-menu"} onClick={() => doChangeStepClick(2)}>
                      <span>
                        <i className="fa fa-address-book fa-2x"></i>
                        <br />
                        Contacts
                      </span>
                    </a>
                    <a className={step == 3 ? "btn text-center property-menu-selected" : "btn text-center property-menu"} onClick={() => doChangeStepClick(3)}>
                      <span>
                        <i className="fa fa-file-text-o fa-2x"></i>
                        <br />
                        Documents
                      </span>
                    </a>
                    <a className={step == 4 ? "btn text-center property-menu-selected" : "btn text-center property-menu"} onClick={() => doChangeStepClick(4)}>
                      <span>
                        <i className="fa fa-pie-chart fa-2x"></i>
                        <br />
                        Finance
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            )}
            {props.dealID == "" ? null : (
              <div className="rightS color2 hidden-md hidden-lg">
                <div className="row">
                  <div className="col-md-12">
                    <a className={step == 0 ? "btn text-center property-menu-selected" : "btn text-center property-menu"} onClick={() => doChangeStepClick(0)}>
                      <i className="fa fa-tachometer fa-2x"></i>
                    </a>
                    <a className={step == 1 ? "btn text-center property-menu-selected" : "btn text-center property-menu"} onClick={() => doChangeStepClick(1)}>
                      <i className="fa fa-clock-o fa-2x"></i>
                    </a>
                    <a className={step == 2 ? "btn text-center property-menu-selected" : "btn text-center property-menu"} onClick={() => doChangeStepClick(2)}>
                      <i className="fa fa-address-book fa-2x"></i>
                    </a>
                    <a className={step == 3 ? "btn text-center property-menu-selected" : "btn text-center property-menu"} onClick={() => doChangeStepClick(3)}>
                      <i className="fa fa-file-text-o fa-2x"></i>
                    </a>
                    <a className={step == 4 ? "btn text-center property-menu-selected" : "btn text-center property-menu"} onClick={() => doChangeStepClick(4)}>
                      <i className="fa fa-pie-chart fa-2x"></i>
                    </a>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="modal fade" id="deal_name_model" tabIndex={-1} role="dialog" aria-labelledby="deal_name_model">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h3 className="modal-title" id="">
                Update Deal Name
              </h3>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-md-12">
                  <div className="form-group">
                    <input type="text" className="form-control" value={dealModelData.dealname} onChange={(e) => inputHandler(e, "dealName")} />
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <div className="col-md-12">
                <button type="button" className="btn btn-default" data-dismiss="modal">
                  <i className="fa fa-times"></i> Cancel
                </button>
                <button className="btn btn-success-oms" onClick={() => onDealNameEditSave()}>
                  <i className="fa fa-check"></i> Save
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="modal fade" id="internal-deal-tag" tabIndex={-1} aria-labelledby="selectTagModelLabel" aria-hidden="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <button type="button" className="close" data-dismiss="modal" aria-hidden="true">
                &times;
              </button>
              <h4 className="modal-title" id="internal-deal-tag-header" style={{ display: "contents" }}>
                Internal Tags
              </h4>{" "}
              &nbsp;
              <a href="https://help.entegral.net/en/articles/10026006-internal-listing-and-deal-tags" target="_blank">
                <i className="fa fa-question-circle" title="Help" style={{ cursor: "pointer" }} aria-hidden="true"></i>
              </a>
            </div>
            <div className="modal-body">
              {internalDealDefaultTags && (
                <div className="internal-deal-tags">
                  {internalDealDefaultTags.map((tagElement, index) => (
                    <span
                      key={index}
                      onClick={() => handleTagClick(index)}
                      className={tagElement.isSelected ? "internal-deal-tags-item active" : "internal-deal-tags-item"}
                    >
                      {tagElement.name}
                    </span>
                  ))}
                </div>
              )}
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-default" data-dismiss="modal">
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
      {isShowAuditTrail === true && (
        <AuditTrailBox id="auditDeal" objectID={newDealData?.dealID} officeID={newDealData?.officeID} onClose={handleAuditTrailClose}></AuditTrailBox>
      )}
    </>
  );
}

export default DealBox;
